import { Theme } from './';

export default (theme: Theme) => ({
    ...theme.typography.textStyles.label,
    color: theme.color.gray70,
});
